<mat-grid-list [cols]="4" rowHeight="2:2" (window:resize)="onResize($event)">
  <div *ngFor="let material of materials">
    <mat-grid-tile>
      <app-material-details [material]='material'></app-material-details>
    </mat-grid-tile>
  </div>
</mat-grid-list>